import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    items: [],
    globalTimelog: {
        active: false,
        project_id: null,
        activity_type: null,
        activity_id: null,
        closable: true,
        isShort: false,
        autoFill: false
    }
};

export default {mutations, actions, state}
